shadow$provide[243] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, clone:{enumerable:true, get:function() {
  return clone;
}}, merge:{enumerable:true, get:function() {
  return merge;
}}, parseQuoted:{enumerable:true, get:function() {
  return parseQuoted;
}}});
const merge = function() {
  const x = {};
  for (const obj of Array.from(arguments)) {
    for (const k in obj) {
      const v = obj[k];
      x[k] = v;
    }
  }
  return x;
};
const clone = o => JSON.parse(JSON.serialize(o));
const parseQuoted = function(str) {
  let accum = "";
  const unescape = str => str = str.replace(/\\/g, "");
  const munch = function(next) {
    if (accum.length) {
      list.push(unescape(accum));
    }
    return accum = next != null ? next : "";
  };
  str = str.split(/(?=(?:\\.|["' ,]))/g);
  let quote = false;
  const list = [];
  for (const chunk of Array.from(str)) {
    const char = chunk[0];
    const token = chunk.slice(1);
    switch(char) {
      case '"':
      case "'":
        if (quote) {
          if (quote === char) {
            quote = false;
            munch(token);
          } else {
            accum += chunk;
          }
        } else {
          if (accum !== "") {
            throw new Error(`ParseError: String \`${str}\` does not contain comma-separated quoted tokens.`);
          }
          quote = char;
          accum += token;
        }
        break;
      case " ":
      case ",":
        if (!quote) {
          munch(token);
        } else {
          accum += chunk;
        }
        break;
      default:
        accum += chunk;
    }
  }
  munch();
  return list;
};

};